import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import { useDonationFormsStore } from '../../store';


export default /*@__PURE__*/_defineComponent({
  __name: 'DonationInfo',
  props: [
    "strings",
		"show_title",
		"top_title",
		"title",
		"tagline",
		"collected",
		"needed",
		"symbol",
		"show_progress",
		"show_collection"
],
  setup(__props, { expose: __expose }) {
  __expose();

const store = useDonationFormsStore();
const props = __props;
const knob = ref();

const knobInt  = () => {
  if ($.fn.knob !== undefined) {
    $(knob.value).knob();
  }
};

onMounted(() => {
  knobInt();
});



const __returned__ = { store, props, knob, knobInt }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})